import React, { FC } from 'react'
import { Grid, Typography, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { HomeSection } from './HomeSection'
import { revenueData } from './HomeTableLists'

const useStyles = makeStyles((theme: Theme) => ({
  topMrg: {
    flexDirection: 'column',
    width: '100%',
    paddingTop: theme.spacing(6),
  },
}))

export const Home: FC = () => {
  const classes = useStyles()

  return (
    <Grid container className={classes.topMrg}>
      <Typography variant={'h1'}>Home</Typography>
      <HomeSection title={'Revenue by Asset'} data={revenueData} />
    </Grid>
  )
}
